module.exports = __webpack_public_path__ + "c80b41e972c8ce508331e72977cf84eb.png";